import { createAction } from 'redux-actions';

export const FIREBASE_CALL = 'FIREBASE/CALL';
// export const CALL_API_SUCCESS = 'API/CALL/SUCCESS';
// export const CALL_API_FAIL = 'API/CALL/FAIL';

export const callFirebase = createAction(FIREBASE_CALL, (firebaseType, data, actionTypes) => ({
  firebaseType,
  data,
  actionTypes,
}));
